import { useState } from "react";
import { api } from "../../../lib/api";
import { Button } from "../../../components/ui/button";
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../../components/ui/dialog";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";

const CONFIRMATION = "Understood";

export function DangerSection() {
	const [open, setOpen] = useState(false);
	const [confirmation, setConfirmation] = useState("");
	const [isResetting, setIsResetting] = useState(false);
	const [status, setStatus] = useState<string | null>(null);

	const canReset = confirmation === CONFIRMATION && !isResetting;

	async function handleReset() {
		if (!canReset) return;

		setIsResetting(true);
		setStatus(null);
		const { error } = await api.admin.danger["reset-database"].post({ confirmation });
		setIsResetting(false);

		if (error) {
			setStatus("reset failed");
			return;
		}

		setConfirmation("");
		setOpen(false);
		setStatus("database reset complete");
	}

	return (
		<div className="space-y-4 max-w-2xl">
			<div className="border border-[#ef444433] px-4 py-4 space-y-3">
				<div>
					<h3 className="text-sm font-mono uppercase tracking-widest text-[#ef4444]">Reset Database</h3>
					<p className="text-xs text-[#555] mt-2">
						Deletes rooms, messages, aliases, blacklist entries, room states, overrides, and config, then restores seed data.
					</p>
				</div>
				<Button variant="destructive" size="sm" onClick={() => setOpen(true)}>
					reset database
				</Button>
				{status && <p className="text-xs text-[#00ffcc66] font-mono">{status}</p>}
			</div>

			<Dialog open={open} onOpenChange={(o) => { setOpen(o); if (!o) setConfirmation(""); }}>
				<DialogContent>
					<DialogHeader>
						<DialogTitle>Reset Database</DialogTitle>
					</DialogHeader>
					<div className="space-y-4">
						<p className="text-xs text-[#ef4444] font-mono leading-relaxed">
							This will permanently delete current chat data and restore seed records.
						</p>
						<div className="space-y-2">
							<Label>Type Understood to confirm</Label>
							<Input
								value={confirmation}
								onChange={(e) => setConfirmation(e.target.value)}
								placeholder={CONFIRMATION}
								onKeyDown={(e) => e.key === "Enter" && handleReset()}
							/>
						</div>
					</div>
					<DialogFooter>
						<DialogClose asChild>
							<Button variant="ghost" size="sm">cancel</Button>
						</DialogClose>
						<Button variant="destructive" size="sm" disabled={!canReset} onClick={handleReset}>
							{isResetting ? "resetting..." : "reset"}
						</Button>
					</DialogFooter>
				</DialogContent>
			</Dialog>
		</div>
	);
}
